'use client';

import { m } from 'framer-motion';
import { ArrowRight, MessageCircle } from 'lucide-react';
import styles from './CTA.module.css';

interface CTAProps {
    title?: string;
    subtitle?: string;
}

export default function CTA({ 
    title = "Siap Mengirimkan Barang Anda?", 
    subtitle = "Dapatkan penawaran terbaik untuk kebutuhan pengiriman cargo Anda. Tim kami siap membantu 24 jam sehari, 7 hari seminggu." 
}: CTAProps) {
    return (
        <section className={styles.cta}>
            <div className={styles.pattern} />
            <div className={styles.glow} />

            <m.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-100px' }}
                transition={{ duration: 0.8 }}
                className={`container ${styles.content}`}
            >
                <m.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.2, duration: 0.6 }}
                    className={styles.textWrapper}
                >
                    <h2 className={styles.title}>
                        {title}
                    </h2>
                    <p className={styles.subtitle}>
                        {subtitle}
                    </p>

                    <div className={styles.actions}>
                        <m.a
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            href="/kontak"
                            className={styles.btnPrimary}
                        >
                            Minta Penawaran
                            <ArrowRight size={20} strokeWidth={2.5} />
                        </m.a>

                        <m.a
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            href="https://wa.me/628567874759"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.btnGhost}
                        >
                            <MessageCircle size={20} />
                            WhatsApp Kami
                        </m.a>
                    </div>
                </m.div>
            </m.div>
        </section>
    );
}
